// extracted by mini-css-extract-plugin
export default {"header":"header_header__hxOsS","identity":"header_identity__8v8M6","actions":"header_actions__VvL+9","title":"header_title__bhBvi","buttons":"header_buttons__IoTki"};